import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AlertBannerComponent,
  DialogShellComponent,
  FilledButtonComponent,
  TextButtonComponent,
} from '@custom-components';
import { TranslateModule } from '@ngx-translate/core';

export interface SharedDeviceDialogData {
  ldn: string;
  // Null when the installations the device feeds could not be read.
  otherInstallations: number | null;
}

// Asks before a change to a device that feeds several installations, which shows on all of them.
// Closes with true when confirmed, or with nothing when cancelled.
@Component({
  selector: 'xemex-shared-device-dialog',
  imports: [
    AlertBannerComponent,
    DialogShellComponent,
    FilledButtonComponent,
    TextButtonComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './shared-device-dialog.component.html',
})
export class SharedDeviceDialogComponent {
  readonly data = inject<SharedDeviceDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef =
    inject<MatDialogRef<SharedDeviceDialogComponent, true>>(MatDialogRef);

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
